<div class="modal-overlay" *ngIf="showModal">
    <div class="modal-content">
      <button class="close-button" (click)="onClose()">&#x2715;</button>
      <ng-content></ng-content>
    </div>
  </div>
  